import React, { useState, useRef } from "react";
import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  makeStyles,
  Snackbar,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MuiAlert from "@material-ui/lab/Alert";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector, useDispatch } from "react-redux";
// import { ProspectChatModal } from "./ProspectChatModal";
import { Tooltip } from "@mui/material";
import {
  RedCross,
  SoftwareReleaseEyeIcon,
  SortIcon,
  TickMark,
  Delete,
} from "../../../LeftNav/SvgIcons";
// import { ProspectCompaignView } from "./ProspectCompaignView";
import ProspectTabsModal from "./ProspectTabsModal";
import ProspectOverviewModal from "./ProspectOverviewModal";
import InteractionHistoryModal from "./InteractionHistoryModal";
import { contactsTypesActions } from "../../../../../store/contactTypes/contactTypesActions";
import ConvertToCustomerModal from "./ConvertToCustomerModal";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import CallWidget from "./Twilo/CallWidget";
import { toast } from "react-toastify";
import CSVFile from "../../../../../components/common/ExportCSVFile/CSVFile";
// import SimpleCallButton from "./Twilo/CallWidget";

const useStyles = makeStyles(theme => ({
  selectedItems: {
    textAlign: "right",
    color: "#8D99A5",
    fontSize: "14px",
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  gridTable: {
    margin: "20px 0px",
  },
  gridHeaderInner: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridHeaderInnerCenter: {
    color: "#A9B2BC",
    fontSize: "12px",
    fontWeight: "700",
    paddingTop: "4px",
    paddingBottom: "4px",
    textAlign: "center",
  },
  gridBodyInner: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
  },
  gridBodyInnerCenter: {
    color: "#464E5F",
    fontSize: "14px",
    fontWeight: "400",
    paddingTop: "16px",
    paddingBottom: "16px",
    textAlign: "center",
  },
  gridHeader: {
    background: "#E5F2FF",
    borderRadius: "6px",
  },
  gridHeaderRow: {
    borderRadius: "6px",
  },
  gridIconCells: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    "& span": {
      cursor: "pointer",
    },
  },
  csvFile: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "flex-end",
  },
  actionButtons: {
    padding: "unset",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  prospectDetailsButton: {
    color: "#3699FF",
    fontSize: "12px",
    fontWeight: "bold",
    padding: "4px 8px",
    border: "1px solid #3699FF",
    borderRadius: "4px",
    textTransform: "none",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "rgba(54, 153, 255, 0.04)",
    },
  },
  clickableName: {
    cursor: "pointer",
    color: "#3699FF",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  fileInput: {
    display: "none",
  },
  uploadButton: {
    backgroundColor: "#3699FF",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#2d80d9",
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      cursor: "not-allowed",
    },
  },
  fileName: {
    marginLeft: "10px",
    color: "#464E5F",
    fontSize: "14px",
  },
  uploadSection: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0px",
  },
  fileInfo: {
    marginLeft: "10px",
    color: "#464E5F",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  fileTypeBadge: {
    backgroundColor: "#E5F2FF",
    color: "#3699FF",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "500",
  },
  callButton: {
    padding: "6px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "transparent",
      "& svg": {
        transform: "scale(1.1)",
      },
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    transition: "all 0.2s ease",
  },
  actionsDropdown: {
    position: "relative",
  },
  dropdownTrigger: {
    padding: "8px",
    "&:hover": {
      backgroundColor: "rgba(54, 153, 255, 0.04)",
    },
  },
  actionsMenu: {
    "& .MuiPaper-root": {
      borderRadius: "8px",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
      minWidth: "220px",
    },
    "& .MuiMenuItem-root": {
      padding: "8px 16px",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "#F5F8FA",
      },
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
  },
  menuItemIcon: {
    marginRight: "12px",
    fontSize: "20px",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const ProspectGenerationGrid = ({
  onOrderBy,
  order,
  LeadsData,
  roomMsgs,
  setRoomMsgs,
  onClearButtonPress,
  setSelectedRoom,
  selectedRoom,
  leadData,
  setLeadData,
  onSendMessage,
  setLoading,
  handleExport,
  loadLeadsGeneration,
}) => {
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const { hubId } = useSelector(state => state.conversationReducer);
  const [openLeadCampaign, setOpenLeadCampaign] = useState(null);
  const [openProspectTabs, setOpenProspectTabs] = useState(null);
  const [openOverview, setOpenOverview] = useState(null);
  const [openInteractionHistory, setOpenInteractionHistory] = useState(null);
  const [openConvertCustomer, setOpenConvertCustomer] = useState(null);
  const [openCallWidget, setOpenCallWidget] = useState(false);
  const [selectedProspectForCall, setSelectedProspectForCall] = useState(null);

  // Dropdown state
  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const [selectedProspectForDropdown, setSelectedProspectForDropdown] =
    useState(null);

  // Teams Call Dialog states
  const [openCallDialog, setOpenCallDialog] = useState(false);
  const [selectedProspectForTeamsCall, setSelectedProspectForTeamsCall] =
    useState(null);

  // Upload states
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error"
  });

  const handleDropdownOpen = (event, prospect) => {
    setDropdownAnchor(event.currentTarget);
    setSelectedProspectForDropdown(prospect);
  };

  const handleDropdownClose = () => {
    setDropdownAnchor(null);
    setSelectedProspectForDropdown(null);
  };

  // Handle Teams Chat link
  const handleTeamsChat = async item => {
    const chatLink = item?.availabilityInfo?.chatlink;
    if (chatLink) {
      const todayDate = new Date().toISOString();

      const payload = {
        prospectId: item.id,
        comments: "Interaction via Teams",
        type: 1, // Assuming 1 is for call remarks/interaction type
        interactionDate: todayDate,
        isContacted: true, // Add checkbox value to payload
      };
      window.open(chatLink, "_blank", "noopener,noreferrer");
      // Make API call using your Redux action
      const response = await dispatch(
        contactsTypesActions.onAddProspectInteraction(payload),
      );
      if (response?.data?.success) {
        loadLeadsGeneration();
      }
    } else {
      toast.error("Sign in to Outlook to start chat.");
    }
  };

  // Handle Teams Call link
  const handleTeamsCall = async item => {
    const callLink = item?.availabilityInfo?.calllink;
    if (callLink) {
      const todayDate = new Date().toISOString();

      const payload = {
        prospectId: item.id,
        comments: "Interaction via Teams",
        type: 1, // Assuming 1 is for call remarks/interaction type
        interactionDate: todayDate,
        isContacted: true, // Add checkbox value to payload
      };

      window.open(callLink, "_blank", "noopener,noreferrer");
      // Make API call using your Redux action
      const response = await dispatch(
        contactsTypesActions.onAddProspectInteraction(payload),
      );
      if (response?.data?.success) {
        loadLeadsGeneration();
      }
    } else {
      toast.error("Sign in to Outlook to join the team's meeting.");
    }
  };

  // Handle name click for overview
  const handleNameClick = prospect => {
    setOpenOverview(prospect);
  };

  const editProspectClick = prospect => {
    history.push({
      pathname: `/prospect-generation/${prospect.id}`,
    });
  };

  const deleteProspectClick = async propect => {
    if (
      window.confirm(
        `${"Are you sure you want to delete"} ${
          propect?.firstName
        } ${"prospect?"}`,
      )
    ) {
      try {
        setLoading(true);
        const response = await dispatch(
          contactsTypesActions.onDeleteProspect(propect.id),
        );
        if (response?.success) {
          loadLeadsGeneration();
          setTimeout(() => {
            toast.success("Prospect deleted successfully!");
          }, 1000);
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        console.error("Error deleting prospect:", error);
        toast.error("Failed to delete prospect");
      } finally {
        setLoading(false);
      }
    }
  };

  // // Handle Call Button Click - Copy phone number and show dialog
  // const handleCallButtonClick = async item => {
  //   if (!item?.contactNo || !item?.availabilityInfo) {
  //     // setSnackbar({
  //     //   open: true,
  //     //   message: "No contact number available for this prospect",
  //     //   severity: "warning",
  //     // });
  //     toast.error("Sign in to Outlook to call prospect.");
  //     return;
  //   }

  //   try {
  //     // Copy phone number to clipboard
  //     await navigator.clipboard.writeText(item.contactNo);

  //     // Store prospect data and show dialog
  //     setSelectedProspectForTeamsCall(item);
  //     setOpenCallDialog(true);
  //   } catch (err) {
  //     console.error("Failed to copy: ", err);
  //     setSnackbar({
  //       open: true,
  //       message: "Failed to copy phone number. Please try again.",
  //       severity: "error",
  //     });
  //   }
  // };

  const handleCallButtonClick = item => {
    // Debug: Log the item to see what's actually coming through
    console.log("Full item object:", item);
    console.log("Contact number value:", item?.contactNo);

    const contact = item?.contactNo;

    // Better validation - check if contact exists AND has actual content
    if (!contact || contact.trim() === "" || contact === "undefined") {
      alert(
        "No contact information available. Please check the contact details.",
      );
      console.error("Invalid contact:", contact);
      return;
    }

    // Remove any trailing/leading whitespace
    const trimmedContact = contact.trim();

    // Check if it's a phone number (contains digits or starts with +, and is not an email)
    const isPhoneNumber =
      /^[\+\d\s\-\(\)]+$/.test(trimmedContact) && !trimmedContact.includes("@");

    let teamsDeepLink;
    if (isPhoneNumber) {
      const cleanNumber = trimmedContact.replace(/\s/g, "").replace(/-/g, "");
      // Verify we have a valid number after cleaning
      if (!cleanNumber || cleanNumber.length < 5) {
        alert("Invalid phone number format");
        return;
      }
      teamsDeepLink = `https://teams.microsoft.com/l/call/0/0?users=4:${encodeURIComponent(cleanNumber)}`;
      console.log("Phone number deep link:", teamsDeepLink);
    } else {
      // For email/Teams user ID - verify it looks like an email
      if (!trimmedContact.includes("@")) {
        alert(
          "Invalid contact format. Please provide email address or phone number.",
        );
        return;
      }
      teamsDeepLink = `https://teams.microsoft.com/l/call/0/0?users=${encodeURIComponent(trimmedContact)}`;
      console.log("Email deep link:", teamsDeepLink);
    }

    // Open in new window
    window.open(teamsDeepLink, "_blank");
  };

  // Handle Open Teams Dial
  const handleOpenTeamsDial = () => {
    // Open msteams://dial in new tab
    window.open("msteams://dial", "_blank", "noopener,noreferrer");
    setOpenCallDialog(false);
    setSelectedProspectForTeamsCall(null);
  };

  // Validate file type
  const isValidFileType = file => {
    const allowedTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const allowedExtensions = [".csv", ".xlsx", ".xls"];

    const fileExtension = "." + file.name.split(".").pop().toLowerCase();

    return (
      allowedTypes.includes(file.type) ||
      allowedExtensions.includes(fileExtension) ||
      file.name.toLowerCase().endsWith(".csv") ||
      file.name.toLowerCase().endsWith(".xlsx") ||
      file.name.toLowerCase().endsWith(".xls")
    );
  };

  // Get file type for display
  const getFileType = file => {
    if (file.name.toLowerCase().endsWith(".csv") || file.type === "text/csv") {
      return "CSV";
    } else if (
      file.name.toLowerCase().endsWith(".xlsx") ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      return "Excel";
    } else if (
      file.name.toLowerCase().endsWith(".xls") ||
      file.type === "application/vnd.ms-excel"
    ) {
      return "Excel";
    }
    return "File";
  };

  // Handle file selection
  const handleFileSelect = event => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!isValidFileType(file)) {
        setSnackbar({
          open: true,
          message:
            "Please select a valid CSV or Excel file (.csv, .xlsx, .xls)",
          severity: "error",
        });
        return;
      }

      // Validate file size (optional: 10MB limit)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        setSnackbar({
          open: true,
          message:
            "File size too large. Please select a file smaller than 10MB",
          severity: "error",
        });
        return;
      }

      setSelectedFile(file);
    }
  };

  // Handle file upload
  const handleFileUpload = async () => {
    if (!selectedFile) {
      setSnackbar({
        open: true,
        message: "Please select a file first",
        severity: "error",
      });
      return;
    }

    setIsUploading(true);

    try {
      const response = await dispatch(
        contactsTypesActions.onUploadProspect(selectedFile),
      );

      // Check if the action returned success
      if (response?.success) {
        const result = response.data;

        // Check the actual API response structure
        if (result?.success) {
          setSnackbar({
            open: true,
            message: "File uploaded successfully!",
            severity: "success",
          });

          // Clear selected file after successful upload
          setSelectedFile(null);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }

          // Refresh the data if needed
          if (onClearButtonPress) {
            onClearButtonPress();
          }
        } else {
          throw new Error(result?.message || "Upload failed");
        }
      } else {
        throw new Error(response?.error || "Upload action failed");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setSnackbar({
        open: true,
        message: error.message || "Failed to upload file. Please try again.",
        severity: "error",
      });
    } finally {
      setIsUploading(false);
    }
  };

  // Trigger file input click
  const handleUploadButtonClick = () => {
    fileInputRef.current?.click();
  };

  // Close snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Paper>
      <Grid container justifyContent='flex-start' style={{ marginTop: "10px" }}>
        <div className={classes.uploadSection} style={{ marginRight: "10px" }}>
          <CSVFile handleExport={handleExport} />
        </div>
        <div className={classes.uploadSection}>
          <input
            ref={fileInputRef}
            type='file'
            accept='.csv,.xlsx,.xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            onChange={handleFileSelect}
            className={classes.fileInput}
          />
          <Button
            style={{
              textTransform: "capitalize",
              color: "#ffffff",
              fontSize: "11px",
              fontWeight: "500",
              padding: "6px 8px",
            }}
            variant='contained'
            color='primary'
            onClick={handleUploadButtonClick}
            disabled={isUploading}>
            {isUploading ? (
              <CircularProgress size={20} style={{ color: "white" }} />
            ) : (
              "Upload CSV File"
            )}
          </Button>

          {selectedFile && (
            <div className={classes.fileInfo}>
              <span>{selectedFile.name}</span>
              <span className={classes.fileTypeBadge}>
                {getFileType(selectedFile)}
              </span>
              <span>({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)</span>
              <button
                className={classes.uploadButton}
                onClick={handleFileUpload}
                disabled={isUploading}
                style={{ marginLeft: "10px" }}>
                {isUploading ? (
                  <>
                    <CircularProgress
                      size={16}
                      style={{ color: "white", marginRight: "8px" }}
                    />
                    Uploading...
                  </>
                ) : (
                  "Upload File"
                )}
              </button>
            </div>
          )}
        </div>
      </Grid>
      {/* File format info */}
      <Grid
        container
        justifyContent='flex-start'
        style={{ marginBottom: "10px" }}>
        <div style={{ padding: "0px 10px", color: "#666", fontSize: "12px" }}>
          <strong>Supported formats:</strong> CSV, XLSX, XLS
          {/* <strong> Expected columns:</strong> FirstName, LastName, Email,
          ContactNo, NickName, DOB */}
        </div>
      </Grid>
      <Table className={classes.gridTabel}>
        <TableHead className={classes.gridHeader}>
          <TableRow className={classes.gridHeaderRow}>
            <TableCell className={classes.gridHeaderInner}>
              First Name
              <TableSortLabel
                active={order?.orderByKey === "firstName"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "firstName",
                    orderVal: order?.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInner}>
              Last Name
              <TableSortLabel
                active={order?.orderByKey === "lastName"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "lastName",
                    orderVal: order?.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Email
              <TableSortLabel
                active={order?.orderByKey === "email"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "email",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Status
              <TableSortLabel
                active={order?.orderByKey === "status"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "status",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Created On
              <TableSortLabel
                active={order?.orderByKey === "CreatedOn"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "CreatedOn",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Follow Up
              <TableSortLabel
                active={order?.orderByKey === "followupDate"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "followupDate",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Last Interaction
              <TableSortLabel
                active={order?.orderByKey === "lastInteractionDate"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "lastInteractionDate",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Contacted
              <TableSortLabel
                active={order?.orderByKey === "isContacted"}
                direction={order?.orderVal === 1 ? "asc" : "desc"}
                onClick={() =>
                  onOrderBy({
                    orderByKey: "isContacted",
                    orderVal: order.orderVal === 0 ? 1 : 0,
                  })
                }
                IconComponent={SortIcon}
                className='sortIcon'
              />
            </TableCell>
            <TableCell className={classes.gridHeaderInnerCenter}>
              Quick Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {LeadsData?.length > 0 ? (
            LeadsData.map((item, index) => (
              <TableRow key={index} className='gridBodyRow'>
                <TableCell className={classes.gridBodyInner}>
                  {item.firstName || "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInner}>
                  {item.lastName || "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.email || "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.status === 3
                    ? "Disqualified"
                    : item.status === 2
                      ? "Converted"
                      : "Open"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.createdOn
                    ? moment(item.createdOn).format("DD-MM-YYYY")
                    : "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.followupDate
                    ? moment(item.followupDate).format("DD-MM-YYYY")
                    : "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.lastInteractionDate
                    ? moment(item.lastInteractionDate).format("DD-MM-YYYY")
                    : "--"}
                </TableCell>
                <TableCell className={classes.gridBodyInnerCenter}>
                  {item.isContacted ? (
                    <TickMark
                      style={{
                        width: "21",
                        height: "20",
                      }}
                    />
                  ) : (
                    <RedCross
                      style={{
                        width: "21",
                        height: "20",
                      }}
                    />
                  )}
                </TableCell>
                <TableCell className={classes.gridIconCells}>
                  <div className={classes.actionsDropdown}>
                    <Tooltip title='Quick Actions' placement='top'>
                      <IconButton
                        className={classes.dropdownTrigger}
                        onClick={e => handleDropdownOpen(e, item)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>

                    <Menu
                      anchorEl={dropdownAnchor}
                      open={
                        Boolean(dropdownAnchor) &&
                        selectedProspectForDropdown?.id === item.id
                      }
                      onClose={handleDropdownClose}
                      className={classes.actionsMenu}>
                      <Tooltip title='Convert to Customer' placement='top'>
                        <MenuItem
                          onClick={() => {
                            setOpenConvertCustomer(item);
                            handleDropdownClose();
                          }}>
                          <ManageAccountsIcon
                            className={classes.menuItemIcon}
                            style={{ color: "rgb(54, 153, 255)" }}
                          />
                          <span>Convert to Customer</span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip title='View Interaction History' placement='top'>
                        <MenuItem
                          onClick={() => {
                            setOpenInteractionHistory(item);
                            handleDropdownClose();
                          }}>
                          <SoftwareReleaseEyeIcon
                            style={{
                              fill: "#BADAFB",
                              fill2: "#4EA5FE",
                              marginRight: "12px",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                          <span style={{ marginLeft: "10px" }}>
                            View Interaction History
                          </span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip
                        title={
                          item?.availabilityInfo
                            ? "Send Email"
                            : "Sign in to Outlook to send emails"
                        }
                        placement='top'>
                        <MenuItem
                          onClick={() => {
                            if (item?.availabilityInfo) {
                              setOpenProspectTabs(item);
                              handleDropdownClose();
                            } else {
                              toast.error("Sign in to Outlook to send emails");
                            }
                          }}>
                          <OpenInNew
                            className={classes.menuItemIcon}
                            style={{
                              color: item?.availabilityInfo
                                ? "#3699FF"
                                : "#ccc",
                            }}
                          />
                          <span
                            style={{
                              color: item?.availabilityInfo ? "#000" : "#ccc",
                            }}>
                            Send Email
                          </span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip
                        title={
                          item?.availabilityInfo?.chatlink
                            ? "Chat on Teams"
                            : "Sign in to Outlook to start chat."
                        }
                        placement='top'>
                        <MenuItem
                          onClick={() => {
                            handleTeamsChat(item);
                            handleDropdownClose();
                          }}>
                          <ChatIcon
                            className={classes.menuItemIcon}
                            style={{
                              color: item?.availabilityInfo?.chatlink
                                ? "#3699FF"
                                : "#ccc",
                            }}
                          />
                          <span
                            style={{
                              color: item?.availabilityInfo?.chatlink
                                ? "#000"
                                : "#ccc",
                            }}>
                            Chat on Teams
                          </span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip
                        title={
                          item?.availabilityInfo?.calllink
                            ? "Call on Teams"
                            : "Sign in to Outlook to join the team's meeting."
                        }
                        placement='top'>
                        <MenuItem
                          onClick={() => {
                            handleTeamsCall(item);
                            handleDropdownClose();
                          }}>
                          <VideoCallIcon
                            className={classes.menuItemIcon}
                            style={{
                              color: item?.availabilityInfo?.calllink
                                ? "#3699FF"
                                : "#ccc",
                              fontSize: "22px",
                            }}
                          />
                          <span
                            style={{
                              color: item?.availabilityInfo?.calllink
                                ? "#000"
                                : "#ccc",
                            }}>
                            Call on Teams
                          </span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip
                        title={
                          item?.contactNo && item?.availabilityInfo
                            ? "Call Prospect"
                            : "Sign in to Outlook to call prospect."
                        }
                        placement='top'>
                        <MenuItem
                          onClick={() => {
                            handleCallButtonClick(item);
                            handleDropdownClose();
                          }}>
                          <CallIcon
                            className={classes.menuItemIcon}
                            style={{
                              color:
                                item?.availabilityInfo && item?.contactNo
                                  ? "#3699FF"
                                  : "#ccc",
                            }}
                          />
                          <span
                            style={{
                              color:
                                item?.availabilityInfo && item.contactNo
                                  ? "#000"
                                  : "#ccc",
                            }}>
                            Call Prospect
                          </span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip title='Prospect Information' placement='top'>
                        <MenuItem
                          onClick={() => {
                            handleNameClick(item);
                            handleDropdownClose();
                          }}>
                          <InfoOutlineIcon
                            className={classes.menuItemIcon}
                            style={{ color: "rgb(54, 153, 255)" }}
                          />
                          <span>Prospect Information</span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip title='Edit Prospect' placement='top'>
                        <MenuItem
                          onClick={() => {
                            editProspectClick(item);
                            handleDropdownClose();
                          }}>
                          <EditIcon
                            className={classes.menuItemIcon}
                            style={{ color: "rgb(54, 153, 255)" }}
                          />
                          <span>Edit Prospect</span>
                        </MenuItem>
                      </Tooltip>

                      <Tooltip title='Delete Prospect' placement='top'>
                        <MenuItem
                          onClick={() => {
                            deleteProspectClick(item);
                            handleDropdownClose();
                          }}>
                          <DeleteIcon
                            className={classes.menuItemIcon}
                            style={{ color: "#EB5757" }}
                          />
                          <span>Delete Prospect</span>
                        </MenuItem>
                      </Tooltip>
                    </Menu>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow key='0' className='gridBodyRow'>
              <TableCell
                colSpan='9'
                className={classes.gridBodyInner}
                style={{ textAlign: "center" }}>
                <span className='emptyGridText'>No Prospect Available.</span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* Existing Modals */}
      <InteractionHistoryModal
        open={openInteractionHistory}
        setOpen={setOpenInteractionHistory}
        prospectData={openInteractionHistory}
        loadLeadsGeneration={loadLeadsGeneration}
      />
      <ProspectTabsModal
        open={openProspectTabs}
        setOpen={setOpenProspectTabs}
        setLoading={setLoading}
        loadAllCampaigns={onClearButtonPress}
        prospectData={openProspectTabs}
        loadLeadsGeneration={loadLeadsGeneration}
      />
      <ProspectOverviewModal
        open={openOverview}
        setOpen={setOpenOverview}
        prospectData={openOverview}
      />
      <ConvertToCustomerModal
        open={openConvertCustomer}
        setOpen={setOpenConvertCustomer}
        prospectData={openConvertCustomer}
        loadLeadsGeneration={loadLeadsGeneration}
      />

      {/* CallWidget Modal */}
      <CallWidget
        open={openCallWidget}
        onClose={() => {
          setOpenCallWidget(false);
          setSelectedProspectForCall(null);
        }}
        prospect={selectedProspectForCall}
        onCallComplete={() => {
          // Optional: Refresh data or update UI after call
          console.log("Call completed");
        }}
        loadLeadsGeneration={loadLeadsGeneration}
      />

      {/* Teams Call Dialog */}
      <Dialog
        open={openCallDialog}
        onClose={() => setOpenCallDialog(false)}
        PaperProps={{
          style: {
            borderRadius: "12px",
            minWidth: "400px",
          },
        }}>
        <DialogTitle style={{ paddingBottom: "8px" }}>
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            Teams Call
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            style={{ color: "#464E5F", fontSize: "14px", lineHeight: "1.5" }}>
            The recipient phone number{" "}
            <strong>{selectedProspectForTeamsCall?.contactNo}</strong> has been
            copied to your clipboard. Open Teams dial pad and paste to initiate
            the call.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px", gap: "12px" }}>
          <Button
            onClick={() => setOpenCallDialog(false)}
            style={{
              textTransform: "capitalize",
              color: "#666",
              fontWeight: 500,
            }}>
            Cancel
          </Button>
          <Button
            onClick={handleOpenTeamsDial}
            variant='contained'
            style={{
              textTransform: "capitalize",
              backgroundColor: "#3699FF",
              color: "#fff",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#2d80d9",
              },
            }}>
            Open Teams
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default ProspectGenerationGrid;
